if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this._handleKeydown = this._handleKeydown.bind(this);
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this._handleKeydown);
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        document.addEventListener('keydown', this._handleKeydown);
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      _getVisibleMedia() {
        // Solo las imágenes visibles (de la variante activa)
        return Array.from(this.querySelectorAll('[data-media-id]')).filter(
          (el) => !el.classList.contains('product__media-item--variant') || el.classList.contains('active') || getComputedStyle(el).display !== 'none'
        );
      }

      _navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const visibleMedia = allMedia.filter(el => {
          const style = getComputedStyle(el);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (visibleMedia.length < 2) return;

        const activeIndex = visibleMedia.findIndex(el => el.classList.contains('active'));
        if (activeIndex === -1) return;

        const nextIndex = (activeIndex + direction + visibleMedia.length) % visibleMedia.length;
        const nextMedia = visibleMedia[nextIndex];

        // Simular apertura del siguiente media
        this.openedBy = { getAttribute: (attr) => nextMedia.getAttribute(attr) };
        this.showActiveMedia();
      }

      _handleKeydown(e) {
        if (e.key === 'ArrowRight') this._navigateMedia(1);
        if (e.key === 'ArrowLeft') this._navigateMedia(-1);
      }
    }
  );
}
